module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_vm._v("Dane firmy")]), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'CompanyUpdate',
        params: {
          id: _vm.item.id
        }
      },
      "title": "Edytuj"
    }
  }, [_c('span', [_vm._v("Edytuj")]), _c('svg-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.updated) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "status"
    }
  }, [_vm._v("Dane firmy zostały zmodyfikowane")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Nazwa")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['name']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIP")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['nip']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("REGON")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['regon']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KRS")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['krs']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Numer konta (PLN)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['bankAccount']['numberPLN']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Numer konta (EUR)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['bankAccount']['numberEUR']))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Adres")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.address.postalCode) + " " + _vm._s(_vm.item.address.city) + ", ul. " + _vm._s(_vm.item.address.street) + " " + _vm._s(_vm.item.address.number) + " " + _vm._s(_vm.item.address.country))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Telefon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.phone))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Strona WWW")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.website))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("E-mail")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.email))])]), _vm._v(" "), (_vm.item.summary) ? _c('tr', [_c('td', [_vm._v("Podsumowanie")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['summary']))])]) : _vm._e()])])])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23516511","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/Show.vue
// module id = 795
// module chunks = 0